import { toDate } from 'date-fns-tz';
import endOfQuarter from 'date-fns/endOfQuarter';
import formatReal from 'date-fns/format';
import isThisYear from 'date-fns/isThisYear';
import startOfQuarter from 'date-fns/startOfQuarter';

import type { SearchResultMercuryFocusArea } from '@atlassian/search-client';

const DEFAULT_DATE_FNS_OPTIONS: {
	weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
} = {
	weekStartsOn: 1, // Start on monday. Week is monday -> sunday.
};

// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const mixinDefaultOptions = <p extends (...args: any[]) => any>(fn: p) => {
	/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
	return function (this: any, ...theArgs: any[]) {
		const lastIndex = fn.length - 1;
		if (fn.length === theArgs.length) {
			theArgs[lastIndex] = {
				...DEFAULT_DATE_FNS_OPTIONS,
				...theArgs[lastIndex],
			};
		} else {
			theArgs[lastIndex] = DEFAULT_DATE_FNS_OPTIONS;
		}
		return fn.apply(this, theArgs);
	} as p;
};

const SAME_YEAR_FORMAT = 'd MMM';
const DIFF_YEAR_FORMAT = 'd MMM yyyy';
const MONTH_ONLY_FORMAT = 'MMMM';
const MONTH_ONLY_FORMAT_SHORT = 'MMM';
const MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';

const format = mixinDefaultOptions(formatReal);

export const getDisplayedFocusAreaTargetDate = (partial: SearchResultMercuryFocusArea) => {
	const { focusArea } = partial;

	if (!focusArea?.targetDate) {
		return null;
	}

	const date = toDate(focusArea.targetDate.targetDate);
	let displayedTargetDate = '';
	if (focusArea?.targetDate.targetDateType === 'DAY') {
		displayedTargetDate = format(date, isThisYear(date) ? SAME_YEAR_FORMAT : DIFF_YEAR_FORMAT);
	} else if (focusArea?.targetDate.targetDateType === 'MONTH') {
		displayedTargetDate = format(
			date,
			isThisYear(date) ? MONTH_ONLY_FORMAT : MONTH_ONLY_FORMAT_DIFF_YEAR,
		);
	} else if (focusArea?.targetDate.targetDateType === 'QUARTER') {
		displayedTargetDate = `${format(startOfQuarter(date), MONTH_ONLY_FORMAT_SHORT)}-${format(
			endOfQuarter(date),
			isThisYear(date) ? MONTH_ONLY_FORMAT_SHORT : MONTH_ONLY_FORMAT_DIFF_YEAR,
		)}`;
	}

	return displayedTargetDate;
};
